import { useCallback } from 'react';
import { FormResponse, Form } from '@app/api';

import { SubmitType } from '../fieldConfigurations';
import { useFormState } from './useFormState';
import { useGetFieldConfiguration } from './useGetFieldConfiguration';
import { useTrackFieldId } from '../../components/TrackApplicationContainer';

export const useRenderField = (options: {
  form?: Form;
  onFinishForm: (response: FormResponse) => any;
}): [() => React.ReactElement | null, { page: number; length: number }] => {
  const [pagination, sendAnswer] = useFormState(options);

  const trackFieldId = useTrackFieldId();

  const getFieldConfiguration = useGetFieldConfiguration(
    options.form,
    pagination.page,
  );

  const renderField = useCallback(() => {
    const { field, fieldConfiguration } = getFieldConfiguration();
    if (!field || !fieldConfiguration) {
      return null;
    }
    trackFieldId(field.id);

    return fieldConfiguration.renderField({
      field,
      onSubmit: sendAnswer,
      submitType: SubmitType.CONTINUE,
    });
  }, [getFieldConfiguration, sendAnswer, trackFieldId]);

  return [renderField, pagination];
};
